import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { TypeService } from "@core/services/type.service";
import { PageType } from "../../../../../../page-type";
import { PromotionsHttpService } from "@api/http/promotions/promotions-http.service";
import { IPromotionBanner } from "@api/models/promotions/promotion-banner-response";
import { LeagueService } from "@core/services/league.service";
import { TeamService } from "@core/services/team.service";
import { AuthDialogService } from "@app/modules/dialog/services/auth-dialog.service";
import { WebviewService } from "@utils/services/webview/webview.service";

@Component({
  selector: "app-promo-banner",
  templateUrl: "./promo-banner.component.html",
  styleUrls: ["./promo-banner.component.scss"],
})
export class PromoBannerComponent implements OnInit {
  @HostBinding("class.hidden") public hidden = true;
  @Input() public banner?: IPromotionBanner;
  @Input() public type?: PageType | string;
  @Input() public openRegistration = false;
  public entityId: string;

  constructor(
    private promotionsHttpService: PromotionsHttpService,
    private leagueService: LeagueService,
    private teamService: TeamService,
    private authDialogs: AuthDialogService,
  ) {}

  public async ngOnInit(): Promise<void> {
    if (!this.banner) {
      await this.getBanner();
    }
    if (!this.banner || !this.banner?.banner) {
      this.hidden = true;
      this.banner = null;
    }
    if (!this.banner) {
      return;
    }
    this.hidden = false;
    if (!this.banner.target_url) {
      return;
    }
    const link = new URL(this.banner.target_url);
    if (!link.searchParams.has("utm_source")) {
      link.searchParams.set("utm_source", "fan.at");
    }
    if (!link.searchParams.has("utm_medium")) {
      link.searchParams.set("utm_medium", "promotion_banner");
    }
    if (!link.searchParams.has("utm_campaign")) {
      link.searchParams.set("utm_campaign", "votings");
    }
    if (TypeService.pageType === PageType.Home) {
      link.searchParams.set("utm_content", "startpage");
    }
    if (TypeService.pageType === PageType.Team) {
      link.searchParams.set("utm_content", "teampage");
    }
    if (TypeService.pageType === PageType.League) {
      link.searchParams.set("utm_content", "leaguepage");
    }
    this.banner.target_url = link.toString();
  }

  public onBannerClick(): void {
    if (this.openRegistration) {
      if (WebviewService.isWebview) {
        WebviewService.sendOpenRegistrationEvent();
      } else {
        this.authDialogs.openRegistration();
      }
    }
  }

  private async getBanner(): Promise<void> {
    if (!this.type) {
      if (TypeService.pageType === PageType.Team) {
        this.type = PageType.Team;
        this.entityId = this.teamService.getCurrentTeamId();
      }
      if (TypeService.pageType === PageType.League) {
        this.type = PageType.League;
        this.entityId = this.leagueService.getCurrentLeagueId();
      }
    }
    if (!this.type) {
      return;
    }
    this.banner = await this.promotionsHttpService.getPromotionBanner(
      this.type as PageType,
      this.entityId
    );
  }
}
